const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/sro/setup.ts';
import { PatAppConfiguration } from 'App/defs/setupDefs';
import textMap from './translations';
import ECheckinForm from 'App/config/sro/eCheckin/ECheckinForm';
import { useECheckinInitialValues } from './eCheckin/initialValues';
import Footer from 'App/config/sro/Footer';

export const configuration: PatAppConfiguration = {
    languages: ['de', 'fr', 'en', 'it'],
    footer: Footer,
    eCheckin: {
        initialValuesHook: useECheckinInitialValues,
        form: ECheckinForm,
    },
    navbarTitle: textMap.navbarTitle,
    welcomeTitle: undefined,
    welcomeText: textMap.welcomeText,
    synedraCardTitle: undefined,
    urls: {
        website: 'https://www.sro.ch',
        loginHelp: undefined,
    },
    customMetaKatMultipleKeys: {
        Countries: 'Lookup/71221995-e5b8-4b70-9b2f-d3400f9105d3/Children',
    },
    customMatomoClientId: undefined,
    bookAppointmentInfo: undefined,
    bookAppointmentSlotOffset: {
        amount: 24,
        unit: 'hours',
    },
    surgeryCardHint: undefined,
    SurgeryCardContactAlert: undefined,
    surgeryAppointmentDeadline: undefined,
    videoCallDisclaimerText: undefined,
    aiaiBotApiKey: undefined,
};

export const { customMetaKatMultipleKeys } = configuration;
